import { render, staticRenderFns } from "./selector.vue?vue&type=template&id=0c13566b"
import script from "./selector.vue?vue&type=script&lang=js"
export * from "./selector.vue?vue&type=script&lang=js"
import style0 from "./selector.vue?vue&type=style&index=0&id=0c13566b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports